module.exports = __webpack_public_path__ + "static/Zoo-91d5e0a4f435a299b5c241e04c070d02.jpg";